<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
        startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      Payoutsel: ["Payment Method", "Paypal", "Stripe"],
      StatSelc: ["Status", "Paid", "Pending"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content">
        <div
          class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
        >
          <h4>Payout</h4>
          <div class="d-flex align-items-center flex-wrap row-gap-3">
            <span class="fs-14 me-2">Sort</span>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Newly Added
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active">Ascending</a>
                <a href="javascript:void(0);" class="dropdown-item">Descending</a>
              </div>
            </div>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Export
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active"
                  >Export as PDF</a
                >
                <a href="javascript:void(0);" class="dropdown-item">Export as Excel</a>
              </div>
            </div>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-printer"></i
            ></a>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              id="filter_search"
              @click="toggleFilterInputs"
              ><i class="ti ti-sort-descending"></i
            ></a>
            <a
              href="javascript:void(0);"
              class="btn btn-dark d-flex justify-content-center align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#set-payout"
              ><i class="ti ti-settings me-2"></i>Set Payout</a
            >
          </div>
        </div>
        <div id="filter_inputs" v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <div class="sel-cal Calendar-icon">
                  <span><i class="ti ti-calendar-month"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select
                  :options="Payoutsel"
                  id="payoutsel"
                  placeholder="Payment Method"
                />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="StatSelc" id="statselc" placeholder="Status" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Payout card -->
          <div class="col-xl-4 col-md-6 d-flex">
            <div class="card w-100">
              <div
                class="card-body d-flex align-items-center justify-content-between p-3"
              >
                <div class="d-flex align-items-center">
                  <span
                    class="app-icon d-flex justify-content-center align-items-center bg-light rounded-circle fs-20 me-2"
                  >
                    <i class="ti ti-wallet"></i>
                  </span>
                  <div>
                    <span class="fs-14">Available Payout</span>
                    <h5>$ <span class="counter">180</span></h5>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <router-link to="/provider/provider-transaction" class="btn btn-dark btn-sm mb-2"
                    >Transactions</router-link
                  >
                  <a
                    href="#"
                    class="btn btn-light btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#withdraw"
                    >Withdraw</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6 d-flex">
            <div class="card w-100">
              <div
                class="card-body d-flex align-items-center justify-content-between p-3"
              >
                <div class="d-flex align-items-center">
                  <span
                    class="app-icon d-flex justify-content-center align-items-center bg-light rounded-circle fs-20 me-2"
                  >
                    <i class="ti ti-wallet"></i>
                  </span>
                  <div>
                    <span class="fs-14">Last Payout</span>
                    <h5>$ <span class="counter">230</span></h5>
                  </div>
                </div>
                <div class="d-flex align-items-end">
                  <router-link to="/provider/provider-transaction" class="btn btn-dark btn-sm"
                    >Transactions</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6 d-flex">
            <div class="card w-100">
              <div
                class="card-body d-flex align-items-center justify-content-between p-3"
              >
                <div class="d-flex align-items-center">
                  <span
                    class="app-icon d-flex justify-content-center align-items-center bg-light rounded-circle fs-20 me-2"
                  >
                    <i class="ti ti-wallet"></i>
                  </span>
                  <div>
                    <span class="fs-14">Next Payout</span>
                    <h5>$ <span class="counter">200</span></h5>
                  </div>
                </div>
                <div class="d-flex align-items-end">
                  <router-link to="/provider/provider-transaction" class="btn btn-dark btn-sm"
                    >Transactions</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- /Payout card -->
        </div>
        <div class="row">
          <div class="provide-table manage-table">
            <div class="table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Payout Date</th>
                    <th>Amount</th>
                    <th>Refunds</th>
                    <th>Fees</th>
                    <th>Total</th>
                    <th>Payment Method</th>
                    <th>Status</th>
                    <th>Payment Processed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>07 Oct 2024</td>
                    <td>$300</td>
                    <td class="text-danger">-$10.00</td>
                    <td class="text-danger">-$10.00</td>
                    <td>$280</td>
                    <td>paypal</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Paid</span
                        >
                      </div>
                    </td>
                    <td>07 Oct 2024</td>
                  </tr>
                  <tr>
                    <td>10 Oct 2024</td>
                    <td>$400</td>
                    <td class="text-danger">-$10.00</td>
                    <td class="text-danger">-$10.00</td>
                    <td>$380</td>
                    <td>Stripe</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-skyblue d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Pending</span
                        >
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>20 Oct 2024</td>
                    <td>$200</td>
                    <td class="text-danger">-$10.00</td>
                    <td class="text-danger">-$10.00</td>
                    <td>$180</td>
                    <td>paypal</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Paid</span
                        >
                      </div>
                    </td>
                    <td>20 Oct 2024</td>
                  </tr>
                  <tr>
                    <td>02 Nov 2024</td>
                    <td>$100</td>
                    <td class="text-danger">-$10.00</td>
                    <td class="text-danger">-$10.00</td>
                    <td>$80</td>
                    <td>paypal</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-skyblue d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Pending</span
                        >
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>15 Nov 2024</td>
                    <td>$300</td>
                    <td class="text-danger">-$10.00</td>
                    <td class="text-danger">-$10.00</td>
                    <td>$280</td>
                    <td>Stripe</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Paid</span
                        >
                      </div>
                    </td>
                    <td>15 Nov 2024</td>
                  </tr>
                  <tr>
                    <td>22 Nov 2024</td>
                    <td>$350</td>
                    <td class="text-danger">-$10.00</td>
                    <td class="text-danger">-$10.00</td>
                    <td>$330</td>
                    <td>paypal</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Paid</span
                        >
                      </div>
                    </td>
                    <td>22 Nov 2024</td>
                  </tr>
                  <tr>
                    <td>04 Dec 2024</td>
                    <td>$280</td>
                    <td class="text-danger">-$10.00</td>
                    <td class="text-danger">-$10.00</td>
                    <td>$260</td>
                    <td>paypal</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Paid</span
                        >
                      </div>
                    </td>
                    <td>04 Dec 2024</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="table-paginate d-flex justify-content-between align-items-center flex-wrap row-gap-3"
          >
            <div class="value d-flex align-items-center">
              <span>Show</span>
              <select>
                <option>7</option>
              </select>
              <span>entries</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <span class="me-2 text-gray-9">1 - 07 of 10</span>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
    <provider-payout-modal></provider-payout-modal>
  </div>
</template>
